import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  setActiveStep,
  setSurveyDetails,
  enableEditSurvey,
} from '../../../actions/turnkeyOmnibusActions';
import { ieSteps } from '../../../util/IEUtils';

const IESurveyListRows = ({
  rows,
  setActiveStep,
  setSurveyDetails,
  enableEditSurvey,
}) => {
  const handleClick = survey => {
    enableEditSurvey(survey);
  };

  const handleNameClick = survey => {
    setSurveyDetails(survey);
    setActiveStep(ieSteps.SURVEY_DETAILS);
  };

  const renderRows = () => {
    const rowItems = _.map(rows, (item, i) => {
      let title = '';

      if (item.status === 'Your Review Required') {
        title = 'Your survey has been reviewed and needs further edits.';
      } else if (item.status === 'Submitted') {
        title = 'Your survey is completed and your data is ready for you.';
      } else if (item.status === 'In field') {
        title = 'Survey is launched and in field collecting data';
      } else if (item.status === 'Processing') {
        title =
          'Your survey has ended and is being fused with your selected data and reviewed for accuracy.';
      } else if (item.status === 'Released') {
        title = 'Your survey is completed and your data is ready for you. ';
      } else {
        title = 'Survey not submitted yet. Click to complete my survey.';
      }

      let status = (
        <span className="column-text" title={title}>
          {item.status}
        </span>
      );
      if (
        item.status === 'Incomplete' ||
        item.status === 'Your Review Required'
      ) {
        status = (
          <button onClick={() => handleClick(item)} title={title}>
            <span className="column-text">{item.status} </span>
            <span className="warning-icon">
              <svg
                width="18"
                height="18"
                fill="none"
                stroke="#dc3545"
                viewBox="0 0 12 12"
              >
                <circle cx="6" cy="6" r="4.5" />
                <path strokeLinejoin="round" d="M5.8 3.6h.4L6 6.5z" />
                <circle cx="6" cy="8.2" r=".6" fill="#dc3545" stroke="none" />
              </svg>
            </span>
          </button>
        );
      }

      return (
        <div className="custom-mri-table--row" key={i}>
          <div className="custom-mri-table--col ie-column-status">{status}</div>
          <div className="custom-mri-table--col ie-column-surveyname">
            <button
              onClick={() => handleNameClick(item)}
              title={item.surveyName}
            >
              <span className="column-text">
                <strong>{item.surveyName}</strong>
              </span>
              <span className="column-text study-name">{item.studyName}</span>
            </button>
          </div>
          <div className="custom-mri-table--col ie-column-createdon">
            <span className="column-text">{item.modifiedOn}</span>
          </div>
          <div
            className="custom-mri-table--col ie-column-creator"
            title={item.creator.trim() || '-'}
          >
            <span className="column-text">{item.creator.trim() || '-'}</span>
          </div>
          <div className="custom-mri-table--col ie-column-category">
            <span className="column-text">{item.categoryName}</span>
          </div>
          <div className="custom-mri-table--col ie-column-surveyid">
            <span className="column-text">{item.projectId}</span>
          </div>
        </div>
      );
    });
    return rowItems;
  };

  return <div className="custom-mri-table--body">{renderRows()}</div>;
};

IESurveyListRows.propTypes = {
  rows: PropTypes.instanceOf(Array),
  setActiveStep: PropTypes.func,
  setSurveyDetails: PropTypes.func,
  enableEditSurvey: PropTypes.func,
};

export default connect(
  null,
  { setActiveStep, setSurveyDetails, enableEditSurvey }
)(IESurveyListRows);
